import { FunctionComponent, useCallback } from "react";
import { kmsConnect, WrappedProps as HOCProps } from "@kaltura/mediaspace-shared-kms-connect";
import { UploadMedia } from "./UploadMedia";
import { QueryParams } from "@kaltura/mediaspace-shared-types";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";
import { UploadMediaBaseProps } from "./UploadMediaBaseProps";

export interface UploadMediaContainerProps extends UploadMediaBaseProps {
    createServiceUrl: string;
    deleteServiceUrl: string;
    checkStatusServiceUrl: string;
}

/**
 * UploadMedia container - for creating UploadMedia page
 */
const UploadMediaContainer: FunctionComponent<UploadMediaContainerProps & HOCProps> = ({
    getFromKms,
    createServiceUrl,
    checkStatusServiceUrl,
    deleteServiceUrl,
    ...rest
}) => {
    const createMedia = useCallback(
        (uploadQuery: QueryParams) => {
            const p: Promise<{ error: boolean; result?: KalturaMediaEntry }> = new Promise((resolve) => {
                getFromKms(
                    uploadQuery,
                    (data: { error: boolean; result?: KalturaMediaEntry }) => {
                        resolve(data);
                    },
                    createServiceUrl,
                    false,
                    false
                );
            });
            return p;
        },
        [getFromKms, createServiceUrl]
    );

    const deleteMedia = useCallback(
        (uploadQuery: QueryParams) => {
            const p: Promise<{ data: Record<string, boolean> }> = new Promise((resolve) => {
                getFromKms(
                    uploadQuery,
                    (data: { data: Record<string, boolean> }) => {
                        resolve(data);
                    },
                    deleteServiceUrl,
                    false,
                    false
                );
            });
            return p;
        },
        [getFromKms, deleteServiceUrl]
    );

    const checkMediaStatus = useCallback(
        (uploadQuery: QueryParams) => {
            const p: Promise<{ result: KalturaMediaEntry[]; error: boolean }> = new Promise((resolve) => {
                getFromKms(
                    uploadQuery,
                    (response: { result: KalturaMediaEntry[]; error: boolean }) => {
                        resolve(response);
                    },
                    checkStatusServiceUrl,
                    false,
                    false
                );
            });
            return p;
        },
        [getFromKms, checkStatusServiceUrl]
    );

    return (
        <UploadMedia
            createMedia={createMedia}
            deleteMedia={deleteMedia}
            checkMediaStatus={checkMediaStatus}
            {...rest}
        />
    );
};

export default kmsConnect(UploadMediaContainer);
